import ProductCard from '@components/_rolex/ProductCard'
import { Box, Spinner } from '@gassan-ui'
import { useDelayLoadingState } from '@lib/hooks/useDelayLoadingState'
import React, { FC } from 'react'
import { getKontentImage, MultipleItemResponse } from '@lib/kontent'
import { RolexProduct } from '@lib/kontent/models/RolexProduct'
import { useLocalization } from '@components/Localization'

interface Props {
  data: MultipleItemResponse<RolexProduct>
  isLoading?: boolean
}

const RolexGrid: FC<Props> = ({ data, isLoading }) => {
  const { lang } = useLocalization()
  // Only displaying a loading state if loading time > 300ms
  const displayLoading = useDelayLoadingState(isLoading, 300)
  return (
    <Box
      display="grid"
      gridTemplateColumns={{ _: '1fr 1fr', small: 'repeat(3, 1fr)' }}
      gridColumnGap="0"
      gridAutoRows="minmax(min-content, max-content)"
      position="relative"
      minHeight={500}
    >
      {displayLoading && (
        <Box
          position="absolute"
          size="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          backgroundColor="rgba(255,255,255,0.5)"
          color="primary"
          zIndex={3}
        >
          <Spinner size={50} />
        </Box>
      )}
      {data.items.map(item => {
        const sources = [
          getKontentImage(item.elements.preview_image_mobile?.value[0]?.url),
          getKontentImage(item.elements.preview_image_desktop?.value[0]?.url)
        ]
        return (
          <ProductCard
            key={item.system.id}
            href={`/${lang}/rolex/${item.elements.rolex_family?.value[0]?.name}/${item.elements.url_slug.value}`}
            sources={sources}
            title={item.elements.title.value}
            subTitle={item.elements.short_description.value}
          ></ProductCard>
        )
      })}
    </Box>
  )
}

export default RolexGrid
